import type { FieldType, RichTextContentProtocol } from '@lighthouse/core'

/** 流程「设置记录内容」新增字段时的占位初值；附件(file)与其它类型均用空 doc 供变量编辑器使用 */
export const getDefaultFiledValue: (type: FieldType) => RichTextContentProtocol = (_type: FieldType) => {
    return {
        type: 'doc',
        content: [
            {
                type: 'paragraph',
                content: []
            }
        ]
    }
}
